import React from "react";
import PropTypes from "prop-types";
import { Tooltip as MUITooltip, Typography } from "@mui/material";

const Tooltip = ({ title, children, ...props }) => {
  return (
    <MUITooltip
      title={<Typography variant="body2">{title}</Typography>}
      PopperProps={{
        // disablePortal: true,
         modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "window",
            },
          },
          {
            name: "flip",
            options: {
              fallbackPlacements: ["left", "top"],
            },
          },
        ],
        sx: { width: "max-content" },
      }}
      {...props}
    >
      {children}
    </MUITooltip>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
};

export default Tooltip;
